import { H1 } from '#app/components/typography/h1.tsx'
import { P } from '#app/components/typography/p.tsx'

export default function GettingStartedRoute() {
	return (
		<>
			<H1>Getting Started</H1>
			<P>You should start by reading the introduction and installation guide.</P>
			<P>This is all you need to get started.</P>
		</>
	)
}
